import SVButton, { SVButtonSIZES, SVButtonUSES } from '@pkgs/shared-client/components/SVButton';
import cn from '@pkgs/shared-client/helpers/cn';
import SVGIconCheck from '@pkgs/shared-client/img/upgrade/icon-check-inlined.svg';

type Feature = {
	label: string;
	soon?: boolean;
};

type Props = {
	features: Feature[];
	className?: string;
	renderFeatureText?: (text: string) => React.ReactNode;
	checkIconClassName?: string;
	featureLabelClassName?: string;
};

const SVUpgradeFeaturesList = ({
	features,
	className = '',
	renderFeatureText,
	checkIconClassName,
	featureLabelClassName,
}: Props) => (
	<ul className={cn('text-primary flex w-full flex-col space-y-3', className)}>
		{features.map((feature, i) => (
			<li key={i} className="flex items-center space-x-3">
				<div className={cn('bg-brand rounded-full p-1', checkIconClassName)}>
					<SVGIconCheck className="h-2 w-2 text-white" />
				</div>
				<span className={cn('type-small', featureLabelClassName)}>
					{renderFeatureText ? renderFeatureText(feature.label) : feature.label}
				</span>
				{feature.soon ? (
					<SVButton
						use={SVButtonUSES.VIOLATOR}
						size={SVButtonSIZES.TINY}
						className="text-primary bg-gray-800 bg-opacity-100 text-[10px] font-semibold opacity-100 ring-0"
						isDisabled={true}
					>
						SOON
					</SVButton>
				) : null}
			</li>
		))}
	</ul>
);

export default SVUpgradeFeaturesList;
